<!-- Simple loading placeholder -->
@if (!showEditor()) {
  <div class="editor-loading-placeholder"></div>
}

@if (showEditor()) {
  <div class="editor-container" [class.fade-out]="!showEditor()" [class.fade-in]="showEditor() && isAnimating()">
    <automata-simplified-automation-editor
      [workflowData]="workflowData()"
      [automation]="automation()"
      [disableTriggerEdit]="disableTriggerEdit()"
      [startInAdvancedMode]="reloadAdvancedMode$$ | async"
      (dataChange)="onDataChange($event)"
      (automationRunStateChange)="onAutomationRunStateChange($event)"
      (isAdvancedModeChange)="onIsAdvancedModeChange($event)"
      (editAutomationDetails)="editAutomationDetails.emit($event)"
    >
    </automata-simplified-automation-editor>
  </div>
}
